import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { images } from 'src/images';

@Component({
  selector: 'app-warning-badge',
  templateUrl: './warning-badge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarningBadgeComponent {
  readonly label = input.required<string>();

  public images = images;
}
